import { createSlice } from "@reduxjs/toolkit";

const initialBillingState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  totalCountInvoiceList: 0,
  invoiceItem: null,
  billingForEdit: undefined,
  invoiceList: [],
  billingInvoice: { plan: {} },
  lastError: null,
};

export const callTypes = {
  list: "list",
  action: "action",
};

export const billingSlice = createSlice({
  name: "billing",
  initialState: initialBillingState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },

    // getBillingById
    billingFetched: (state, action) => {
      state.actionsLoading = false;
      state.listLoading = false;
      state.error = null;
      state.billingInvoice = action.payload.billingInvoice;
      state.invoiceItem = action.payload.invoiceItem;
    },
    invoiceFetched: (state, action) => {
      state.listLoading = false;
      state.error = null;
      state.invoiceList = action.payload.invoiceList;
      state.totalCountInvoiceList = action.payload.total_items;
    },
    // Set to default state actionLoading & error
    billingReload: (state, action) => {
      state.actionsLoading = false;
      state.listLoading = false;
      state.error = null;
    },
  },
});
